import { useTranslation } from 'react-i18next';
import { useCaseData, useCaseId } from '../../../hooks';
import './iprTab.scss';
import { useOrthBoundStore } from '../../stores/useStore';
import { useEffect, useState } from 'react';
import { CaseVersionDTO } from '../../../shared';

export function IprTab() {
  const [t] = useTranslation();
  const [caseId] = useCaseId();
  const { patientCase, getPatientCaseVersion } = useCaseData(caseId);
  const { currentVersion } = useOrthBoundStore();
  const [patientCaseVersion, setPatientCaseVersion] = useState<CaseVersionDTO>();

  useEffect(() => {
    const getLegacyPlan = async () => {
      if (currentVersion) {
        const caseVersion = await getPatientCaseVersion(currentVersion.id);
        setPatientCaseVersion(caseVersion);
      }
    };

    getLegacyPlan();
  }, [currentVersion, patientCase]);

  return (
    <div className="ipr-tab">
      {patientCaseVersion ? (
        <>
          {patientCaseVersion?.data.legacyPlan?.stripping?.map((stripping) => (
            <div className="ipr-tab__item">
              <div className="ipr-tab__title">
                {stripping?.number} - {stripping?.title}
              </div>
              {stripping?.description.split('\r\n').map((line) => (
                <div> {line}</div>
              ))}
            </div>
          ))}
        </>
      ) : (
        ''
      )}
    </div>
  );
}
